<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Details</h2>
      <p class="step-text">
        Geben Sie die Eckpunkte der Wohnung an. Mehrfachnennungen sind möglich.
      </p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <SelectBox
          class="box-item small-icon-w-50"
          text="Lift"
          v-model="fields.flagLift.value"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_73.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_73_white.svg')
          "
        />
        <SelectBox
          class="box-item small-icon-w-50"
          text="Balkon / Loggia"
          v-model="fields.flagBalkon.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7903.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7903_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-50"
          text="Terrasse"
          v-model="fields.flagTerrasse.value"
          :iconDefault="require('@/assets/icons/Svgs/terrasse.svg')"
          :iconHover="require('@/assets/icons/Svgs/terrasse_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-80"
          text="(Tief-)garage"
          v-model="fields.flagGarage.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7987.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7987_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-80"
          text="Garten"
          v-model="fields.flagGarten.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7899.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7899_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectBox from "@/components/shared/SelectBox.vue";
import { getFromStorage, saveToStorage, isSet } from "@/utils.js";
export default {
  name: "wohnung-step-8a",
  components: {
    SelectBox,
  },
  data() {
    return {
      fields: {
        flagLift: { value: "false" },
        flagBalkon: { value: "false" },
        flagGarage: { value: "false" },
        flagGarten: { value: "false" },
        flagTerrasse: { value: "false" },
        whgBalkonM2: { value: null },
        whgGartenM2: { value: null },
        TerrasseM2: { value: null },
        whgGaragenStk: {value: null},
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      saveToStorage(this.fields);
      this.$router.push("/wohnung-step-7");
    },
    goNext() {
      if (!isSet(this.fields.flagBalkon.value)) {
        this.fields.whgBalkonM2.value = null;
      }
      if (!isSet(this.fields.flagGarten.value)) {
        this.fields.whgGartenM2.value = null;
      }
      if (!isSet(this.fields.flagGarage.value)) {
        this.fields.whgGaragenStk.value = null;
      }
      if (!isSet(this.fields.flagTerrasse.value)) {
        this.fields.TerrasseM2.value = null;
      }
      saveToStorage(this.fields);
      if (
        isSet(this.fields.flagBalkon.value) ||
        isSet(this.fields.flagGarten.value) ||
        isSet(this.fields.flagGarage.value) ||
        isSet(this.fields.flagTerrasse.value)
      ) {
        this.$router.push("/wohnung-step-8b");
      } else {
        this.$router.push("/wohnung-step-9");
      }
    },
  },
  mounted() {
    this.$emit("setStep", "wohnung", 9);
    getFromStorage(this.fields);
  },
};
</script>
